import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Route, Redirect, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

class AuthenticatedRoute extends Component {
    constructor(props) {
        super(props);
        this.checkSecurity = this.checkSecurity.bind(this);
    }

    checkSecurity() {
        const Component = this.props.component;
        return (
            this.props.isAuthenticated ?
                <Component /> :
                <Redirect to={{pathname: '/login', state: {from: this.props.location}}} />
        );
    }

    render() {
        return <Route render={this.checkSecurity} />;
    }
}

AuthenticatedRoute.propTypes = {
    location: PropTypes.object,
    component: PropTypes.any,
    isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.auth.logged,
    };
};

export default withRouter(connect(mapStateToProps)(AuthenticatedRoute));
